// src/context/BookingContext.jsx
import React, { createContext, useContext } from "react";
import useRealtimeBookings from "../hooks/useRealtimeBookings";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const bookingsState = useRealtimeBookings(); // ✅ NO ARGS

  return (
    <BookingContext.Provider value={bookingsState}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) {
    throw new Error("useBooking must be used within BookingProvider");
  }
  return ctx;
};
